import React from 'react'
import styles from './AboutSection.module.css'

/* Swap with your team / studio photo (R2 / CDN / local import).
   Or pass as a prop: <AboutSection image="https://your-link/team.jpg" /> */
const ABOUT_IMAGE =
  'https://pub-f369b33409cf4a599883d7bec60d1538.r2.dev/113.png'

const AboutSection = ({ image = ABOUT_IMAGE }) => {
  return (
    <section id="about" className={styles.section}>
      <div className={styles.container}>
        <span className={styles.eyebrow}>About Us</span>

        <h2 className={styles.heading}>
          No matter the event, we bring strategy, creativity, and precision to
          make your moments unforgettable
        </h2>

        <div className={styles.body}>
          {/* Image */}
          <div className={styles.imageWrap}>
            <img src={image} alt="The Collective KatalyX team" className={styles.image} />
          </div>

          {/* Cards */}
          <div className={styles.cards}>
            <article className={`${styles.card} ${styles.cardWide}`}>
              <h3 className={styles.cardTitle}>Our Vision</h3>
              <p className={styles.cardText}>
                At Collective KatalyX, we envision a world where every corporate
                gathering is more than an event — it&apos;s a catalyst. We blend
                strategy, creativity, and operational precision to turn business
                objectives into experiences that strengthen brands and connect
                people, from intimate team meetings to conferences for thousands.
              </p>
            </article>

            <article className={styles.card}>
              <h3 className={styles.cardTitle}>Our Values</h3>
              <p className={styles.cardText}>
                We&apos;re guided by strategy, creativity, and a deep commitment to
                excellence. We immerse ourselves in your organisation, then design
                experiences backed by detailed analysis — so every brief, stage
                cue, and guest moment delivers.
              </p>
            </article>

            <article className={styles.card}>
              <h3 className={styles.cardTitle}>Our Goals</h3>
              <p className={styles.cardText}>
                Our mission is simple: measurable impact. Whether it&apos;s a MICE
                conference, an award night, a product launch, or a leadership
                off-site, we design and execute experiences that inspire, engage,
                and deliver real outcomes.
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection